import { Box, Typography } from '@mui/material';
import Image from 'next/image';
import { landingAssets } from '../landing-assets';
import { landingContent, landingCtas } from '../landing-content';
import { landingPalette } from '../landing-theme';
import { LandingCtaButton } from './LandingCtaButton';
import { LandingEyebrow } from './LandingEyebrow';
import { SectionShell } from './SectionShell';

/** Above-the-fold hero. The mockup is the LCP element, so it loads with priority. */
export function LandingHero() {
  const { hero } = landingContent;

  return (
    <SectionShell
      sx={{
        display: 'grid',
        // Text column widened slightly vs. the original 0.82fr split: SectionShell's wider
        // md gutter (40px vs. the old 20px) trims ~80px off the available row width, which
        // was enough to push "Ticket plans built for fans." onto a third line.
        gridTemplateColumns: { xs: '1fr', md: '0.88fr 1.12fr' },
        alignItems: 'center',
        gap: { xs: 3, md: 6 },
        py: { xs: 8, md: 12 },
      }}
    >
      <Box>
        <LandingEyebrow>{hero.eyebrow}</LandingEyebrow>
        <Typography variant="h1" component="h1" sx={{ mb: 3 }}>
          {hero.title}
        </Typography>
        <Typography
          sx={{
            maxWidth: 640,
            mb: 4,
            color: '#c8c8c8',
            fontSize: 'clamp(1rem, 1.5vw, 1.25rem)',
          }}
        >
          {hero.lede}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
          <LandingCtaButton cta={landingCtas.learnMore} variant="primary" />
          <LandingCtaButton cta={landingCtas.contactUs} variant="outline" />
        </Box>
      </Box>

      <Box sx={{ position: 'relative', bgcolor: landingPalette.ink }}>
        <Image
          src={landingAssets.heroMockup}
          alt={hero.imageAlt}
          width={1200}
          height={780}
          sizes="(max-width: 900px) 100vw, 58vw"
          priority
          style={{ width: '100%', height: 'auto' }}
        />
      </Box>
    </SectionShell>
  );
}
